import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import PrivateRoutes from './privateRoutes';
import PublicRoutes from './publicRoutes';
import { isUserInLocalStorage } from '../containers/Auth/auth.action';

class ProtectedRouter extends Component {
    componentWillMount () {
        this.props.isUserInLocalStorage();
    }

    smartRender () {
        if (this.props.userRedirect) {
            return <PrivateRoutes />;
        } else {
            return <PublicRoutes {...this.props} />;
        }
    }

    render () {
        return (
            <div className='wrapper'>
                {this.smartRender()}
            </div>
        );
    }
}

const mapStateToProps = ({ appState, auth }) => {
    const { userRedirect } = appState;
    const { isAuthenticated } = auth;
    return { userRedirect, isAuthenticated };
};

export default withRouter(connect(mapStateToProps, { isUserInLocalStorage })(ProtectedRouter));



// WEBPACK FOOTER //
// ./src/routes/protectedRouter.js